<template>
    <f7-page ref="self" :page-content="false" class="change-short-name-page">
        <f7-navbar>
            <f7-nav-left>
                <a href="#" class="link icon-only" @click="back">
                    <i class="icon-back icon"></i>
                </a>
            </f7-nav-left>
            <f7-nav-title>
                {{ $t("g.settings.changeName.title") }}
            </f7-nav-title>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <f7-page-content>
            <list-input-with-title
                :title="$t('g.settings.changeName.title')"
                v-model:text="shortName"
                :placeholder="$t('g.settings.changeName.placeholder')"
                :required="true"
                :hint="$t('g.settings.changeName.hint')"
            />
            <f7-block>
                <f7-button class="flex-1" fill :disabled="isButtonDisabled" preloader :loading="loading" @click="save">
                    {{ $t("g.settings.changeName.submit") }}
                </f7-button>
            </f7-block>
        </f7-page-content>
    </f7-page>
</template>

<script lang="ts">
import { f7 } from 'framework7-vue';
import { defineComponent, ref } from "@vue/runtime-core";
import ServiceAccount from "@/services/v2/data/service-account/ServiceAccount";
import ErrorsService from "@/services/errors-service/ErrorsService";
import ListInputWithTitle from "@components/atomic/list-item/ListInputWithTitle.vue";

export default defineComponent({
	components: {ListInputWithTitle},
    setup() {
        const account = ServiceAccount.of().account;
        const shortName = ref(account.value?.shortName ?? '');
        const startedShortName = shortName.value;
        const loading = ref(false);

        return {
            loading,
            shortName,
            startedShortName,
            account
        }
    },
    computed: {
        isButtonDisabled(): boolean {
            return !Boolean(this.shortName.length) || this.shortName === this.startedShortName;
        }
    },
    methods: {
        back() {
            f7.view.main.router.back();
        },
        async save() {
            try {
                if (this.isButtonDisabled) return;
                this.loading = true;
                await ServiceAccount.of().patchAccount({name: this.shortName});
                f7.view.main.router.back();
            } catch (e: any) {
                await ErrorsService.of().handle(e);
            } finally {
                this.loading = false;
            }
        }
    }
});
</script>

<style lang="scss">
.change-short-name-page {
    .title-wrapper {
        align-items: center;
        margin: 27px 16px 5px;
        display: flex;
        justify-content: flex-start;
        gap: 8px;
        cursor: pointer;

        .title {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            text-transform: uppercase;
            color: #818E95;
        }
    }
    .form {
        .input-wrapper  {
            position: relative;
            &::after {
                content: '';
                position: absolute;
                background-color: var(--grey4);
                display: block;
                z-index: 15;
                top: auto;
                right: 0px;
                bottom: 0;
                left: auto;
                height: 1px;
                width: 100%;
                transform-origin: 50% 100%;
                transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
            }
            &::before {
                content: '';
                position: absolute;
                background-color: var(--grey4);
                display: block;
                z-index: 15;
                top: 0;
                right: 0px;
                bottom: auto;
                left: auto;
                height: 1px;
                width: 100%;
                transform-origin: 50% 100%;
                transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
            }
            .short-name {
                width: 100%;
                padding: 12px 16px;
                background-color: #FFF;
                height: 44px;
                @include text(16px, 400, var(--brown1));
                position: relative;

                &::placeholder {
                    color: #BFBFBF;
                }
            }
        }
        .hint {
            padding: 8px 16px 0px;
            @include text(14px, 400, #818E95, 16.8px);
        }

        & + .block {
            margin-top: 40px;
        }
    }
}
</style>
